import type { JSX } from 'react';

import { Typography } from '@mui/material';
import { INamedEntity } from 'common/components/sharedCustomComponents/Common/helpers';
import { AclResource, UserGroupDropdownOption, UserGroupWithCreationFlag } from 'common/types/Entities';

export const displayEntityMenuItemContent = (option: INamedEntity): JSX.Element => {
    return (
        <Typography>
            {option.name}
        </Typography>
    );
};

export const getAclResourceOptionLabel = (option: AclResource): string => {
    return option.displayName
        ? `${option.displayName} (${option.name})`
        : option.name;
};

export const displayAclResourceMenuItemContent = (option: AclResource): JSX.Element => {
    return (
        <>
            <Typography>
                {option.displayName || option.name}
            </Typography>
            <Typography
                variant="body1"
                gutterBottom
                color="info.light"
                noWrap
            >
                {option.displayName ? option.name : ''}
            </Typography>
        </>
    );
};

export const filterAclResourceOptionsCustomCallback = (
    option: AclResource,
    input: string
): boolean => {
    const name = option?.name?.toLowerCase() || '';
    const display = option?.displayName?.toLowerCase() || '';
    const search = input?.toLowerCase();
    return name.includes(search) || display.includes(search);
};

export const filterUserGroupOptionsCustomCallback = (
    option: UserGroupDropdownOption,
    input: string
): boolean => {
    if ((option as UserGroupWithCreationFlag).shouldDisplayCreateNewUserGroupFields) {
        return true;
    }

    const name = option?.name?.toLowerCase() || '';
    const search = input?.toLowerCase();
    return name.includes(search);
};
